import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import FormattedName from 'I18n/components/FormattedName';
import H2 from 'UIComponents/elements/headings/H2';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIPaginator from 'UIComponents/paginator/UIPaginator';
import UIPanel from 'UIComponents/panel/UIPanel';
import UIPanelBody from 'UIComponents/panel/UIPanelBody';
import UIPanelFooter from 'UIComponents/panel/UIPanelFooter';
import UIPanelHeader from 'UIComponents/panel/UIPanelHeader';
import UITable from 'UIComponents/table/UITable';
import UITruncateString from 'UIComponents/text/UITruncateString';
import Track from './utils/trackers/QualifiedLeadSidebarCardTracker';
import { HANDOFF_TYPES } from './constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PAGE_SIZE = 20;
function renderHeaders() {
  return /*#__PURE__*/_jsxs("tr", {
    children: [/*#__PURE__*/_jsx("th", {
      children: /*#__PURE__*/_jsx("b", {
        children: "Date"
      })
    }), /*#__PURE__*/_jsx("th", {
      children: /*#__PURE__*/_jsx("b", {
        children: "Handoff Type"
      })
    }), /*#__PURE__*/_jsx("th", {
      children: /*#__PURE__*/_jsx("b", {
        children: "Contact"
      })
    }), /*#__PURE__*/_jsx("th", {
      children: /*#__PURE__*/_jsx("b", {
        children: "Raised by"
      })
    })]
  });
}
function renderRow(submission) {
  const {
    contact,
    submitter
  } = submission;
  return /*#__PURE__*/_jsxs("tr", {
    children: [/*#__PURE__*/_jsx("td", {
      width: 135,
      children: /*#__PURE__*/_jsx(FormattedDateTime, {
        "data-test-id": "date",
        value: submission.submittedAt,
        format: "ll",
        type: "userTz"
      })
    }), /*#__PURE__*/_jsx("td", {
      width: 170,
      children: /*#__PURE__*/_jsx("span", {
        "data-test-id": "handoff-type",
        children: HANDOFF_TYPES[submission.handoffType]
      })
    }), /*#__PURE__*/_jsx("td", {
      children: contact.email ? /*#__PURE__*/_jsxs(UITruncateString, {
        maxWidth: 125,
        children: [/*#__PURE__*/_jsx(FormattedName, {
          "data-test-id": "contact",
          email: contact.email,
          familyName: contact.familyName,
          givenName: contact.givenName
        }), /*#__PURE__*/_jsx("br", {}), `(${contact.email})`]
      }) : /*#__PURE__*/_jsx("span", {
        "data-test-id": "contact",
        children: contact.vid
      })
    }), /*#__PURE__*/_jsx("td", {
      children: /*#__PURE__*/_jsx(UITruncateString, {
        maxWidth: 125,
        children: /*#__PURE__*/_jsx(FormattedName, {
          "data-test-id": "raised-by",
          email: submitter.email,
          familyName: submitter.familyName,
          givenName: submitter.givenName
        })
      })
    })]
  }, submission.id);
}
function QualifiedLeadsHistoryPanel(props) {
  useEffect(() => {
    Track.viewFullHistory();
  }, []);
  const [offset, setOffset] = useState(0);
  return /*#__PURE__*/_jsxs(UIPanel, {
    animate: false,
    width: 720,
    children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
      className: "m-right-3",
      "data-test-id": "close-button",
      onClick: props.onClose
    }), /*#__PURE__*/_jsx(UIPanelHeader, {
      children: /*#__PURE__*/_jsx(H2, {
        "data-test-id": "heading",
        children: "Company Inbound Qualified Lead History"
      })
    }), /*#__PURE__*/_jsx(UIPanelBody, {
      children: /*#__PURE__*/_jsxs(UITable, {
        bordered: true,
        condensed: true,
        "data-test-id": "table",
        children: [/*#__PURE__*/_jsx("thead", {
          children: renderHeaders()
        }), /*#__PURE__*/_jsx("tbody", {
          children: props.submissions.slice(offset, offset + PAGE_SIZE).map(renderRow)
        })]
      })
    }), props.submissions.length > PAGE_SIZE ? /*#__PURE__*/_jsx(UIPanelFooter, {
      align: "center",
      children: /*#__PURE__*/_jsx(UIPaginator, {
        "data-test-id": "paginator",
        maxVisiblePageButtons: 0,
        onPageChange: ({
          target: {
            value
          }
        }) => setOffset((value - 1) * PAGE_SIZE),
        pageCount: Math.ceil(props.submissions.length / PAGE_SIZE)
      })
    }) : null]
  });
}
QualifiedLeadsHistoryPanel.propTypes = {
  onClose: PropTypes.func.isRequired,
  submissions: PropTypes.array.isRequired
};
export default QualifiedLeadsHistoryPanel;